import { UtilsService } from './providers/utils/utils.service';
// Angular Modules
import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
// Other Modules
import { AuthServiceModule } from '@pluritech/auth-service';
import { ServerServiceModule } from '@pluritech/server-service';
import { PaginationModule } from '@pluritech/pagination';
import { Ng2TableModule } from '@pluritech/ng2-responsive-table';
import { DialogServiceModule } from '@pluritech/dialog-service';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { BootstrapModalModule } from 'ng2-bootstrap-modal';
import { FileUploadModule } from 'ng2-file-upload/file-upload/file-upload.module';
import { ToasterModule } from 'angular2-toaster';
import { NgxMaskModule } from 'ngx-mask';
import { QuillModule } from 'ngx-quill';
// Component
import { AppComponent } from './app.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ContentLoaderComponent } from './components/content-loader/content-loader.component';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
// Parts
import { DashComponent } from './parts/dash/dash.component';
//  Pages
import { MainComponent } from './pages/main/main.component';
import { LoginComponent } from './pages/login/login.component';
// Router config
import { AppRoutingModule } from './app-routing.module';
// Services
import { AuthenticationService } from './_services/authentication.service';

import { ChangePasswordService } from './_services/changePassword.service';

import { LoginService } from './providers/login/login.service';
// Guards
import { UnauthenticatedGuard } from './guards/unauthenticated/unauthenticated.guard';
import { AuthenticatedGuard } from './guards/authenticated/authenticated.guard';
// Configurations Files
import { configuration } from './configuration';
//new file
//import { NgDatepickerModule } from 'ng2-datepicker';
import { NgDatepickerModule } from 'ng2-datepicker';
//import { LoadingPageModule, MaterialBarModule } from 'angular-loading-page';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
//import { fakeBackendProvider } from './_helpers';
import { JwtInterceptor } from './_helpers';
import { PlanmasterComponent } from './component/planmaster/planmaster.component';
import { PlanmasteraddeditComponent } from './component/planmasteraddedit/planmasteraddedit.component';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import {NgxPaginationModule} from 'ngx-pagination';
import { TestmasterComponent } from './component/testmaster/testmaster.component';
import { AddedittestComponent } from './component/addedittest/addedittest.component';
import { SpecialitymasterComponent } from './component/specialitymaster/specialitymaster.component';
import { AddeditspecialityComponent } from './component/addeditspeciality/addeditspeciality.component';
//import { YourchildcompnameComponent } from './plainsight/yourchildcompname/yourchildcompname.component';
import { AddeditorganisationComponent } from './component/addeditorganisation/addeditorganisation.component';
import { OrganisationmasterComponent } from './component/organisationmaster/organisationmaster.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import {AuthGuard} from'./auth.guard'

import {NotificationService} from './_services/notification.service'

import {CommonService} from './_services/common.service'
import {SpecialityService} from './_services/speciality.service'
import {TestService} from './_services/test.service'
import {OrganisationsService} from './_services/organisations.service';
import { AddeditNotificationMasterComponent } from './component/addedit-notification-master/addedit-notification-master.component'

import { NotificationMasterComponent } from './component/notificationmaster/notification-master.component'
import {MatTabsModule} from '@angular/material/tabs';
import { ReversePipe } from './pipes/reverse.pipe';

import {MatSnackBarModule} from '@angular/material';
import { OrganisationTypeMasterComponent } from './component/organisation-type-master/organisation-type-master.component';
import { AddeditorganisationTypeComponent } from './component/addeditorganisation-type/addeditorganisation-type.component';
import { QueueTemplateComponent } from './component/queue-template/queue-template.component';
import { AddeditQueueTemplateComponent } from './component/addedit-queue-template/addedit-queue-template.component';
import { LanguageMasterComponent } from './component/language/language-master/language-master.component';
import { AddeditLanguageComponent } from './component/language/addedit-language/addedit-language.component';
import { ChangepasswordComponent } from './component/changepassword/changePassword.component';
import { NumberDirective } from './directive/number-only.directive';
import { ForgotpasswordComponent } from './component/forgotpassword/forgotpassword.component';
import { NgxPasswordToggleModule } from 'ngx-password-toggle';
import { commonInterceptor } from './interceptors/common-interceptors';
import { responseInterceptors } from './interceptors/response-interceptors';

@NgModule({
  declarations: [
    NumberDirective,
    ChangepasswordComponent,
    AppComponent,
    LoginComponent,
    DashComponent,
    LoaderComponent,
    MainComponent,
    ContentLoaderComponent,
    PlanmasterComponent,
    PlanmasteraddeditComponent,
    TestmasterComponent,
    AddedittestComponent,
    SpecialitymasterComponent,
    AddeditspecialityComponent,
    AddeditorganisationComponent,
    OrganisationmasterComponent,
    AddeditNotificationMasterComponent,
    NotificationMasterComponent,
    ReversePipe,
    OrganisationTypeMasterComponent,
    AddeditorganisationTypeComponent,
    QueueTemplateComponent,
    AddeditQueueTemplateComponent,
    LanguageMasterComponent,
    AddeditLanguageComponent,
    ForgotpasswordComponent,
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    NgxPasswordToggleModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    ChartsModule,
    RouterModule.forRoot([]),
    AppRoutingModule,
    AuthServiceModule.forRoot(configuration.localStorageKey),
    ServerServiceModule.forRoot(),
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    PaginationModule,
    BootstrapModalModule,
    FileUploadModule,
    ToasterModule.forRoot(),
    QuillModule,
    Ng2TableModule,
    DialogServiceModule.forRoot(),
    NgxMaterialTimepickerModule.forRoot(),
    RouterModule,
    NgDatepickerModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    NgxMyDatePickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    MatTabsModule,
    MatSnackBarModule

  ],
  entryComponents: [],
  providers: [
    CommonService,
    NotificationService,
    SpecialityService,
    TestService,
    OrganisationsService,
    LoginService,
    AuthGuard,
    AuthenticationService,
    ChangePasswordService,
    UtilsService,
    { provide: HTTP_INTERCEPTORS, useClass: commonInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: responseInterceptors , multi: true },

  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(applicationRef: ApplicationRef) {
    Object.defineProperty(applicationRef, '_rootComponents', {get: () => applicationRef['components']});
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts